import { render } from "./CampaignCreate.vue?vue&type=template&id=667faed4&scoped=true"
import script from "./CampaignCreate.vue?vue&type=script&lang=js"
export * from "./CampaignCreate.vue?vue&type=script&lang=js"

import "./CampaignCreate.vue?vue&type=style&index=0&id=667faed4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667faed4"]])

export default __exports__